require.register("app/ui/modal/Waiting", function(exports, require, module){
  $0
  
});

